import './App.css';

function App() {
  return (
    <div className="App">
        <h1>Pocket Aces App Policy</h1>
      <div className="policy-content">
        <h2>1. Introduction</h2>
        <p>
          Welcome to Pocket Aces! Our app is designed to enhance your gaming experience by helping you log and track game sessions on your own device. We prioritize user privacy and ensure that all data is kept locally, solely accessible to you.
        </p>

        <h2>2. Data Storage and Privacy</h2>
        <p>
          <strong>Local Data Storage:</strong> All session data (e.g., session total, hours played) is stored on your device only. Pocket Aces currently does not collect, store, or access your data remotely.
        </p>
        <p>
          <strong>Potential Future Updates:</strong> In future versions, we may integrate an optional cloud service to provide data backup and syncing across devices. If this occurs, you will be informed and given a choice to opt in.
        </p>

        <h2>3. User Responsibilities</h2>
        <p>
          <strong>Data Backup:</strong> Since data is stored locally, users are responsible for backing up their data, especially if the app or device is uninstalled or replaced.
        </p>
        <p>
          <strong>Compliance:</strong> Users must comply with all applicable laws and regulations while using the app.
        </p>

        <h2>4. Changes to This Policy</h2>
        <p>
          We may update this policy if data storage practices change, including any future integrations with cloud services. Major updates will be clearly communicated within the app, allowing users to review and accept any changes.
        </p>

        <h2>5. Contact Us</h2>
        <p>
          For any questions or concerns about this policy, please contact us at <a href="mailto:tonycoweb2@gmail.com">tonycoweb2@gmail.com</a>.
        </p>
      </div>
    </div>
  );
}

export default App;
